// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"82f91835","156":"5300bf35","239":"0f72e397","440":"09eb64d4","453":"49ace5de","455":"d8921805","457":"3cd7d988","551":"f2ee53e9","842":"9b6213ae","851":"351f6fb9","977":"68227fbe","980":"81e79e1f"}[chunkId] + ".chunk.js";
};